/**
 * @summary: Represents information about a property that has changed.
 * @description: Contains information to identify the property, what it's old was and what the new value is
 */
export class PropertyChangedInformation {
    public propertyName: string = '';
    public oldValue: any | null;
    public newValue: any | null;

    constructor();
    constructor(propertyName: string, oldValue: any, newValue: any);
    constructor(propertyName?: string, oldValue?: any, newValue?: any) {
        if (propertyName !== undefined) {
            this.propertyName = propertyName;
            this.oldValue = oldValue;
            this.newValue = newValue;
        }
    }
}

export class PropertyChangedInformationHelper {
    public static hasAnyPropertyChanged(
        changes: PropertyChangedInformation[] | null | undefined,
        propertyNames: string[]
    ): boolean {
        if (!changes || changes.length === 0) {
            return false;
        }

        const match = new Set(propertyNames.map((name) => name.toLowerCase()));
        return changes.some((change) =>
            match.has((change.propertyName ?? '').toLowerCase())
        );
    }
}